import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { RED_COLOR } from '../../styles/colors';
import { ActionCostIndicator } from './actionCostIndicator';
const X_ICON_CSS = css `
  color: ${RED_COLOR};
`;
export const ActionCostDisplay = ({ value, canAfford }) => {
    return (_jsxs(Typography, { variant: 'subtitle2', children: [canAfford ? _jsx(ActionCostIndicator, {}) : _jsx("span", { css: X_ICON_CSS, children: "\u00D7" }), value.toLocaleString()] }));
};
